import videojs from 'video.js';

function getContent(options) {
  let el = videojs.dom.createEl('div', {className: 'vjs-promo-code-content'});
  el.insertAdjacentHTML('afterbegin', `
    <button class="vjs-promo-code-content__close"></button>
    <div class="vjs-promo-code-content__title">Промокод</div>
    <div class="vjs-promo-code-content__code">${options.code}</div>
    <div class="vjs-promo-code-content__description">${options.description}</div>
    <button class="vjs-promo-code-content__copy-and-close">Скопировать и закрыть</button>
  `);
  return el;
}

class PromoCodeModal extends videojs.getComponent('ModalDialog') {
  constructor(player, options) {
    super(player, videojs.mergeOptions(options, {content: getContent(options), temporary: false}));
    this.addClass('vjs-promo-code-modal');
    // Copy promo code
    const copyAndcloseEl = this.content().querySelector('.vjs-promo-code-content__copy-and-close');
    if (copyAndcloseEl) {
      copyAndcloseEl.addEventListener('click', () => {
        if (navigator.clipboard) {
          navigator.clipboard.writeText(options.code);
        } else {
          let input = document.createElement('input');
          input.value = options.code;
          input.style.cssText = 'position: fixed; top: 0; left: 0;'; // Avoid scrolling
          player.el().append(input);
          input.focus();
          input.select();
          document.execCommand('copy');
          player.el().removeChild(input);
        }
        this.close();
      });
    }
    // Close modal
    const closeEl = this.content().querySelector('.vjs-promo-code-content__close');
    closeEl.addEventListener('click', () => {
      this.close()
    });
  }
}

videojs.registerComponent('PromoCodeModal', PromoCodeModal);

